import { Injectable } from '@angular/core';

type Platform = 'shopify' | 'nuvemshop' | 'vtex' | 'slicksell' | 'other';

@Injectable({ providedIn: 'root' })
export class PlatformService {

  identifyPlatform(): Platform {
    // 1) ✅ Fonte principal: objeto store (setado pelo backend)
    const fromStore = this.getPlatformFromStore();
    if (fromStore) {
      localStorage.setItem('ss_cart_platform', fromStore);
      return fromStore;
    }

    // 2) Fallback: key antiga
    const storedPlatform = localStorage.getItem('ss_cart_platform') as Platform | null;
    if (storedPlatform) return storedPlatform;

    // 3) Heurística (último recurso)
    let platform: Platform = 'other';

    if ((window as any).Shopify?.routes) {
      platform = 'shopify';
    } else if (
      (window as any).LS ||
      (window as any).Tiendanube ||
      (window as any).Nuvem ||
      window.location.hostname.includes('mitiendanube.com') ||
      window.location.hostname.includes('lojavirtualnuvem.com.br')
    ) {
      platform = 'nuvemshop';
    } else if ((window as any).vtex) {
      platform = 'vtex';
    } else if (
      window.location.hostname.includes('slicksell.link') ||
      window.location.hostname.includes('stage.slicksell.link') ||
      window.location.hostname.includes('app.slicksell.com.br') ||
      window.location.hostname.includes('localhost')
    ) {
      platform = 'slicksell';

      // init ss-cart (se você ainda usa isso)
      if (!localStorage.getItem('ss-cart')) {
        localStorage.setItem('ss-cart', JSON.stringify({
          token: '',
          note: '',
          attributes: {},
          original_total_price: 0,
          total_price: 0,
          total_discount: 0,
          total_weight: 0,
          item_count: 0,
          items: [],
          requires_shipping: false,
          currency: '',
          items_subtotal_price: 0,
          cart_level_discount_applications: []
        }, null, 4));
      }
    }

    localStorage.setItem('ss_cart_platform', platform);
    return platform;
  }

  getStoredPlatform(): Platform {
    return this.identifyPlatform();
  }

  private getPlatformFromStore(): Platform | null {
    try {
      const raw = localStorage.getItem('store');
      if (!raw) return null;

      const store = JSON.parse(raw);
      const p = (store?.ssCartPlatform || store?.ss_cart_platform || store?.ss_cart_platform)?.toString()?.toLowerCase();

      if (!p) return null;
      if (p.includes('shopify')) return 'shopify';
      if (p.includes('nuvemshop')) return 'nuvemshop';
      if (p.includes('vtex')) return 'vtex';
      if (p.includes('slicksell')) return 'slicksell';

      return 'other';
    } catch {
      return null;
    }
  }
}
